<template>
  <div class="group" :class="{ 'no-margin': noMargin }">
    <label>
      <slot></slot>
    </label>
    <span v-if="additional" class="info-wrapper">
      {{ additional }}
    </span>
    <span v-if="error" class="error-wrapper">
      <img class="information-icon" src="@/assets/images/icons/i_error.svg" />
        {{ error }}
    </span>
    <input
      :value="value"
      :type="passwordType"
      :name="name"
      @input="update($event.target.value)"
      @change="update($event.target.value)"
      :required="required"
      :class="{ 'invalid': error || applyErrorStyle }"
    />
    <font-awesome-icon
      class="password-icon"
      :class="{ 'text-grey-2': hidePassword }"
      :icon="passwordIcon"
      @click="hidePassword = !hidePassword"
    />
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  data() {
    return {
      hidePassword: true,
      type: 'password',
    };
  },
  props: {
    name: String,
    value: [String, Number],
    required: { type: Boolean, default: true },
    error: String || undefined,
    applyErrorStyle: Boolean || undefined,
    additional: { type: String, default: undefined },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    passwordType() {
      return this.hidePassword ? 'password' : 'text';
    },
    passwordIcon() {
      return this.hidePassword ? 'eye' : 'eye-slash';
    },
  },
  methods: {
    update(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:active,
input:-webkit-autofill:focus {
  background-color: #fff !important;
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
}

.information-icon {
  max-width: 16px;
  max-height: 16px;
  display: flex;
}

.error-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  @apply text-sm mb-2;
  line-height: 18px;
  color: #AB2017;
}

.info-wrapper {
  @apply text-sm mb-2;
  color: #3E4A5C;
}
.group {
  @apply relative flex flex-col;
  margin-bottom: 2rem;

  &.no-margin {
    margin-bottom: 0;
  }

  input {
    @apply w-full bg-transparent text-black px-4 block border border-grey-task text-lg;
    padding-top: 14px;
    padding-bottom: 14px;
    border-radius: 0.25rem;
    &.invalid {
      border-color: #AB2017;
      background-color: #FFEDED;
    }
    &:focus {
      @apply border-grey-3;
      outline: none;
    }
  }
  label {
    @apply mb-2 text-black-2;
  }
  .password-icon {
    @apply absolute cursor-pointer mr-3 text-grey-2;
    right: 0;
    bottom: 18px;
    transition: 0.3s;
    @media screen and (min-width: 768px) {
      bottom: 18px;
      &:hover{
        @apply text-grey-3
      }
    }
  }
}
</style>
